import { PersonContactForm } from '@/components/form/person-contact-form';
import InfoJson from '@/config/info.json';
import { InlineWidget } from 'react-calendly';

export default function ContactPage() {
  return (
    <div className="flex px-8 flex-col mt-0 lg:mt-14">
      {!!InfoJson.calendlyUrl && (
        <section className="py-8 border-gray-100" id="contactus">
          <h2 className="text-xl md:text-3xl mb-5 font-semibold uppercase text-center">
            BOOK A MEETING WITH {InfoJson.name}
          </h2>
          <InlineWidget url={InfoJson.calendlyUrl} />
        </section>
      )}

      <section className="py-8 border-gray-100" id="contactus">
        <h2 className="text-xl md:text-3xl mb-5 font-semibold uppercase text-center">
          Want to get in touch with {InfoJson.name}?
        </h2>
        <h3 className="text-center font-normal mb-7">Leave a message here</h3>
        <PersonContactForm />
      </section>
    </div>
  );
}
